<template>
  <div class="relative">
    <van-popup v-model="toggle" round position="bottom">
      <CameraComp v-if="toggle" @photo="takePhoto" />
    </van-popup>

    <van-cell-group inset :title="title || 'Ambil Foto'">
      <van-cell
        :title="`Buka Kamera ${minimum > pictures.length ? `(${minimum - pictures.length} foto)` : ''}`"
        @click="() => (toggle = true)"
        label="Tekan untuk mengambil foto dan lagi"
      >
        <template #icon>
          <v-icon icon="ph:camera" class="text-2xl my-auto ml-2 mr-4" />
        </template>
        <!-- right icon -->
        <template #right-icon>
          <v-icon icon="ph:plus" class="text-2xl my-auto" />
        </template>
      </van-cell>
      <template v-for="(picture, index) in pictures">
        <van-cell :key="index">
          <template>
            <div>
              <van-button
                size="small"
                @click="
                  (a) => {
                    pictures.splice(index, 1);
                  }
                "
                class="absolute top-0 right-0 z-10 rounded-md text-red-600 shadow"
              >
                <v-icon icon="ph:trash-simple-bold" class="text-lg" />
              </van-button>
            </div>
            <div class="flex my-2 gap-2">
              <van-image @click="openPreview" :src="picture.url" width="7rem" height="7rem" fit="contain" />
              <van-field
                v-model="picture.description"
                rows="3"
                autosize
                type="textarea"
                maxlength="50"
                placeholder="Deskripsi foto (opsional)"
                show-word-limit
              />
            </div>
          </template>
        </van-cell>
      </template>
    </van-cell-group>
  </div>
</template>

<script>
  import CameraComp from "@/components/Inputs/CameraComp.vue";
  import { ImagePreview } from "vant";

  export default {
    components: {
      CameraComp
    },
    props: {
      title: String,
      limit: {
        type: Number,
        default: 1
      },
      minimum: {
        type: Number,
        default: 1
      }
    },
    data() {
      return {
        toggle: false,
        pictures: []
      };
    },
    emits: ["selected"],
    watch: {
      pictures: {
        handler(val) {
          this.$emit("selected", { pictures: val, isPassLimit: val.length >= this.minimum });
          // console.log(val);
        },
        immediate: true,
        deep: true
      }
    },
    computed: {},
    methods: {
      takePhoto(photo) {
        const url = URL.createObjectURL(photo);
        this.pictures.push({ url, picture: photo });
        this.toggle = false;
      },
      openPreview() {
        ImagePreview({ images: this.pictures.map((x) => x.url), closeable: true });
      }
    }
  };
</script>
